module.exports = __webpack_public_path__ + "img/Sonja Holtzhausen.83b7e432.png";